import { CatalogContextProvider } from 'modules/catalog/catalogSelector';
import { LocalesContextProvider } from 'utils/contexts/locales/localeSettings';
import { CatalogPreviewContextProvider } from './contexts/CatalogPreviewContext';
import { CatalogQueryDrawerContent } from './CatalogQueryDrawerContent';
import { CatalogSelectionContextProvider } from './contexts/CatalogSelectionContext';

export const CatalogQueryDrawer = () => (
  <LocalesContextProvider>
    <CatalogContextProvider>
      <CatalogPreviewContextProvider>
        <CatalogSelectionContextProvider>
          <CatalogQueryDrawerContent />
        </CatalogSelectionContextProvider>
      </CatalogPreviewContextProvider>
    </CatalogContextProvider>
  </LocalesContextProvider>
);
